import { Record } from 'immutable';
import {
  GLOBAL_ALERT_UPDATE_RECIPE_IN_EDIT_ALERT,
  GLOBAL_ALERT_UPDATE_MENU_IN_EDIT_ALERT,
  GLOBAL_ALERT_UPDATE_MENU_IN_EDIT_ALERT_INFO,
  GLOBAL_ALERT_UPDATE_RECIPE_MOVE_ALERT,
  GLOBAL_ALERT_UPDATE_BATCH_RECIPE_MOVE_ALERT,
  GLOBAL_ALERT_RESET_STATE,
} from 'actions/globalAlert';

export const MENU_EDIT_MODE_DUPLICATE = 'duplicate';
export const MENU_EDIT_MODE_DEFAULT = '';
/**
 * extract global lock alert because this alert may be thrown in
 * multiple places, even may be thrown from action call exceptions.
 *
 * add disable style in front end will still let lock occupied by others if
 * the lock expires 30 min
 *
 * in this case we need to capture error message from back end and show
 * neccesary message.
 *
 * menu, recipe should all follow this way. now will only do for menu
 */
const initialValue = {
  recipeInEditAlert: false,
  menuInEditAlert: false,
  menuInEditMenuTitle: '',
  menuInEditLockedBy: '',
  menuInEditAlertMode: MENU_EDIT_MODE_DEFAULT,
  menuInEditMessage: '',
  recipeMoveAlert: false,
  batchRecipeMoveAlert: false,
};

export const GlobalAlert = Record(initialValue);

const initialState = GlobalAlert(initialValue);

export function formatMenuAlert(title, lockedBy, mode) {
  const menuInEditMessage = `${ lockedBy } is editing "${ title }".`;
  if (mode === MENU_EDIT_MODE_DUPLICATE) {
    return `${ menuInEditMessage } But still you can duplicate the menu with last saved data.`;
  }

  return `${ menuInEditMessage } Please try again later.`;
}

const actionsMap = {
  [GLOBAL_ALERT_UPDATE_MENU_IN_EDIT_ALERT]: (state, action) => {
    return state.merge({
      menuInEditAlert: action.open,
    });
  },
  [GLOBAL_ALERT_UPDATE_MENU_IN_EDIT_ALERT_INFO]: (state, action) => {
    const stagedState = state.merge(action.info);

    const message = formatMenuAlert(
      stagedState.get('menuInEditMenuTitle'),
      stagedState.get('menuInEditLockedBy'),
      stagedState.get('menuInEditAlertMode')
    );

    return stagedState.merge({
      menuInEditMessage: message,
    });
  },
  [GLOBAL_ALERT_UPDATE_RECIPE_IN_EDIT_ALERT]: (state, action) => {
    return state.merge({
      recipeInEditAlert: action.open,
    });
  },
  [GLOBAL_ALERT_UPDATE_RECIPE_MOVE_ALERT]: (state, action) => {
    return state.merge({
      recipeMoveAlert: action.open,
    });
  },
  [GLOBAL_ALERT_UPDATE_BATCH_RECIPE_MOVE_ALERT]: (state, action) => {
    return state.merge({
      batchRecipeMoveAlert: action.open,
    });
  },
  [GLOBAL_ALERT_RESET_STATE]: () => {
    return initialState;
  },
};

export default function globalAlert(state = initialState, action = {}) {
  const fn = actionsMap[action.type];
  return fn ? fn(state, action) : state;
}
